var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _rect2, _rect3, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptySummary = function SvgEmptySummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255,
    height: 199,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160.31,
    height: 160.31,
    x: 98.522,
    y: 1.173,
    stroke: "#000",
    strokeOpacity: 0.06,
    strokeWidth: 1.916,
    rx: 2.874,
    transform: "rotate(15 98.522 1.173)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M167.973 49.207a38.67 38.67 0 0 1 18.599 11.315 37.96 37.96 0 0 1 9.416 19.477 37.4 37.4 0 0 1-2.813 21.338 37.62 37.62 0 0 1-14.131 16.296l-7.091-10.839a24.84 24.84 0 0 0 9.327-10.756 24.7 24.7 0 0 0 1.856-14.083 25.05 25.05 0 0 0-6.215-12.855 25.5 25.5 0 0 0-12.275-7.468z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M179.307 117.951a38.3 38.3 0 0 1-20.893 6.079 38.3 38.3 0 0 1-20.838-6.289 38.27 38.27 0 0 1-14.042-16.621 38.2 38.2 0 0 1-2.701-21.577l12.835 2.128a25.2 25.2 0 0 0 1.784 14.241 25.25 25.25 0 0 0 9.267 10.97 25.275 25.275 0 0 0 27.543.139z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M121.004 79.6a38 38 0 0 1 7.964-17.702l10.266 8.194a25.1 25.1 0 0 0-5.256 11.684z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M128.749 62.338a38.26 38.26 0 0 1 15.547-11.54l4.806 12.08a25.26 25.26 0 0 0-10.261 7.616zM144.424 50.723a38.9 38.9 0 0 1 14.44-2.635l.001 12.9a25.7 25.7 0 0 0-9.53 1.739z",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M158.469 47.662c1.611-.01 3.218.085 4.812.288l-1.864 13.385a24 24 0 0 0-3.177-.19zM163.572 48.358a32 32 0 0 1 4.385.844l-3.401 12.756a21 21 0 0 0-2.894-.557z",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.87,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "m155.56 77.177-.093.345-1.107-.297.092-.345zm1.439.386-.093.345-1.107-.297.092-.345zm1.439.385-.092.345-1.108-.296.093-.345zm1.44.386-.093.345-1.107-.297.092-.345zm1.439.386-.092.345-1.108-.297.093-.345zm1.439.386-.092.345-1.107-.297.092-.345zm1.44.385-.093.345-1.107-.297.092-.344zm1.439.386-.092.345-1.108-.297.093-.345zm1.44.386-.093.344-1.107-.296.092-.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "m157.604 89.402-.246.92-2.953-.792.246-.92zm3.426.917-.247.92-2.953-.791.246-.92z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m107.825 14.576 14.806 3.967-.662 2.468-14.805-3.967zM85.727 121.723l46.886 12.563-.661 2.468-46.886-12.563zM83.413 130.36l46.886 12.562-.661 2.468-46.886-12.563zM81.098 138.996l46.886 12.563-.661 2.468-46.886-12.563zM206.027 153.957l6.17 1.653-.662 2.468-6.17-1.653zM203.712 162.594l6.17 1.653-.662 2.468-6.17-1.653zM201.398 171.23l6.17 1.653-.662 2.468-6.17-1.653zM125.098 19.204l7.403 1.984-.661 2.468-7.403-1.984z",
    opacity: 0.66
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m79.558 120.07 2.468.66-.661 2.468-2.468-.661zM77.243 128.706l2.468.661-.661 2.468-2.468-.661zM74.929 137.343l2.468.661-.661 2.468-2.468-.661zM199.857 152.304l2.468.661-.661 2.468-2.468-.661zM197.543 160.941l2.468.661-.661 2.468-2.468-.661zM195.229 169.578l2.468.661-.661 2.468-2.468-.661z",
    opacity: 0.99
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 162.226,
    height: 162.226,
    y: 18.23,
    fill: "#F9FAFB",
    rx: 3.832
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 160.31,
    height: 160.31,
    x: 0.958,
    y: 19.188,
    stroke: "#000",
    strokeOpacity: 0.06,
    strokeWidth: 1.916,
    rx: 2.874
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M80.474 47.61a38.67 38.67 0 0 1 20.894 6.115A37.96 37.96 0 0 1 115.504 70.1a37.4 37.4 0 0 1 2.806 21.34 37.63 37.63 0 0 1-9.432 19.398l-9.655-8.635a24.85 24.85 0 0 0 6.226-12.803 24.7 24.7 0 0 0-1.852-14.084 25.06 25.06 0 0 0-9.33-10.809 25.5 25.5 0 0 0-13.79-4.036z",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M109.215 111.078a38.3 38.3 0 0 1-18.609 11.279 38.3 38.3 0 0 1-21.755-.681 38.27 38.27 0 0 1-17.865-12.421 38.2 38.2 0 0 1-8.194-20.142l12.95-1.267a25.2 25.2 0 0 0 5.407 13.294 25.26 25.26 0 0 0 11.79 8.198 25.28 25.28 0 0 0 26.641-6.995z",
    opacity: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M42.972 89.124a38 38 0 0 1 3.11-19.16L58.12 75.22a25.1 25.1 0 0 0-2.053 12.646z",
    opacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M45.985 70.445a38.27 38.27 0 0 1 12.03-15.172l7.77 10.425a25.26 25.26 0 0 0-7.94 10.013zM58.12 55.169a38.9 38.9 0 0 1 13.266-6.282l3.34 12.459a25.7 25.7 0 0 0-8.755 4.146z",
    opacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M70.894 48.577q2.331-.64 4.723-.968l1.664 13.412c-1.051.144-2.093.357-3.118.64zM76.003 47.929a32 32 0 0 1 4.454-.32l.017 13.202a21 21 0 0 0-2.94.21z",
    opacity: 0.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.87,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M75.723 77.84v.356h-1.146v-.357zm1.49 0v.356h-1.146v-.357zm1.49 0v.356h-1.146v-.357zm1.49 0v.356h-1.146v-.357zm1.49 0v.356h-1.146v-.357zm1.49 0v.356h-1.146v-.357zm1.491 0v.356h-1.147v-.357zm1.49 0v.356h-1.146v-.357zm1.49 0v.356h-1.146v-.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M80.862 89.118v.952h-3.057v-.952zm3.546 0v.952h-3.057v-.952z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M13.412 29.726H28.74v2.555H13.412zM19.799 138.941h48.54v2.555h-48.54zM19.799 147.882h48.54v2.555h-48.54zM19.799 156.824h48.54v2.555h-48.54zM144.342 138.941h6.387v2.555h-6.387zM144.342 147.882h6.387v2.555h-6.387zM144.342 156.824h6.387v2.555h-6.387zM31.296 29.726h7.664v2.555h-7.664z",
    opacity: 0.66
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M13.412 138.941h2.555v2.555h-2.555zM13.412 147.882h2.555v2.555h-2.555zM13.412 156.824h2.555v2.555h-2.555zM137.956 138.941h2.555v2.555h-2.555zM137.956 147.882h2.555v2.555h-2.555zM137.956 156.824h2.555v2.555h-2.555z",
    opacity: 0.99
  })));
};
export default SvgEmptySummary;